import "./DesktopWhyUs.css";
import { useLang } from "../../../../i18n/LangContext";

/**
 * Desktop-only секция с 3 карти.
 * props:
 *  - id: string (default "why-us")
 *  - icons: [png1, png2, png3]  // PNG-и за трите карти
 *  - iconAlts: ["", "", ""]     // по желание
 */
export default function DesktopWhyUs({
  id = "whyus",
  icons = [],
  iconAlts = ["Global", "Transparency", "Technology"],
}) {
  const { t } = useLang();
  const data = t?.whyUs;
  if (!data) return null;

  return (
    <section id={id} className="why-root why-desktop" aria-label="Why us">
      <div className="why-wrap">
        {/* TOP CENTER HEAD */}
        <div className="why-head">
          <p className="why-eyebrow">{t.whyUs.eyebrow}</p>
          <h2 className="why-title">
            {t.whyUs.titleLine1}<br />{t.whyUs.titleLine2}
          </h2>
        </div>

        {/* THREE CARDS */}
        <div className="why-grid">
          {data.cards?.slice(0, 3).map((card, i) => (
            <article key={i} className="why-card">
              {/* top decorative dot */}
              <span className="why-dot why-dot--top" aria-hidden="true" />

              {/* icon with ring */}
              <div className="why-icon-wrap" aria-hidden={icons[i] ? "false" : "true"}>
                <div className="why-icon-ring-main">
                  <div className="why-icon-ring">
                    {icons[i] ? (
                      <img
                        className="why-icon-img"
                        src={icons[i]}
                        alt={iconAlts[i] || ""}
                        loading="lazy"
                      />
                    ) : (
                      <div className="why-icon-ph" />
                    )}
                  </div>
                </div>
              </div>

              {/* titles */}
              <header className="why-card-head">
                <h3 className="why-card-title">{card.title}</h3>
                {card.subtitle && <div className="why-card-kicker">{card.subtitle}</div>}
              </header>

              {/* text */}
              <p className="why-card-desc">{card.text}</p>

              {/* bottom tiny dot */}
              <span className="why-dot why-dot--bottom" aria-hidden="true" />
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
